import Vue from 'vue'
import App from './App.vue'
import axios from 'axios' //追記
import VueAxios from 'vue-axios' //追記
import store from '@/store'
import "bootstrap/dist/css/bootstrap.min.css"

import router from './router'

Vue.config.productionTip = false

Vue.use(VueAxios, axios) //追記

new Vue({
  router,
  render: h => h(App),
  store
}).$mount('#app')
